<template>
  <div class="tooltip-box ml-1">
    <slot />
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9941 5.99706C11.9941 9.27191 9.2778 11.9941 5.99706 11.9941C2.72219 11.9941 0 9.27191 0 5.99706C0 2.71631 2.71631 0 5.99117 0C9.27191 0 11.9941 2.71631 11.9941 5.99706ZM5.03872 4.90934C4.79177 4.90934 4.59774 5.10337 4.59774 5.33854C4.59774 5.59137 4.79177 5.77363 5.03872 5.77363H5.68543V8.53697H4.93874C4.68594 8.53697 4.49191 8.731 4.49191 8.96617C4.49191 9.219 4.68594 9.40125 4.93874 9.40125H7.40226C7.65506 9.40125 7.84908 9.219 7.84908 8.96617C7.84908 8.731 7.65506 8.53697 7.40226 8.53697H6.65554V5.46203C6.65554 5.13277 6.49091 4.90934 6.17931 4.90934H5.03872ZM5.1504 3.11024C5.1504 3.55709 5.50317 3.90986 5.94414 3.90986C6.38508 3.90986 6.732 3.55709 6.732 3.11024C6.732 2.6634 6.38508 2.31063 5.94414 2.31063C5.50317 2.31063 5.1504 2.6634 5.1504 3.11024Z"
        fill="#53BBAD"
      />
    </svg>
    <div
      :class="{ tooltipTextLong: tooltipText.length > 40, tooltipTextShort: tooltipText.length <= 40, tooltip: true }"
    >
      <span class="text text-xs font-normal">
        {{ tooltipText }}
        <img
          v-if="isAloIccid"
          class="tooltip-image mt-2 mb-2"
          src="https://doc.alo.es/img/alo_sim_ejemplo.jpg"
          alt="Alo ICCID "
        />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tooltipText: {
      type: String,
      required: true,
    },
    isAloIccid: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-image {
  border-radius: 0.3rem;
}
</style>
